(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-main"]) return;
  try {
    
  $('.faqTopicTitle').on('click', function() {
    let $this = $(this);
    let $topic = $this.parent();
    let $items = $topic.find('.faqTopicItems');
    let isExpanded = $topic.attr('aria-expanded') !== 'false';
    
    if(!isExpanded) {
      $items.slideDown(200);
    } else {
      $items.slideUp(200);
    }

    $topic.attr('aria-expanded', !isExpanded);
  });

    document.addEventListener("DOMContentLoaded",function(event) {

        $('#fileButton').on('click', function() {
            $('#ContactFormFile').click();
        });
        var previewImages = function(input, placeholder) {
            $(placeholder).html('');
            if (input.files) {
                let filesAmount = input.files.length;
                for (let i = 0; i < filesAmount; i++) {
                    let button = $('<div class="selectedFileRemoveButton"></div>');
                    button.on('click', function () {
                        let dt = new DataTransfer();
                        let files = input.files;

                        for (let j = 0; j < files.length; j++) {
                            let file = files[j];
                            if (i !== j)
                                dt.items.add(file) // here you exclude the file. thus removing it.
                        }

                        input.files = dt.files ;
                        previewImages(input, placeholder);
                    });
                    let fileElem = $('<div class="selectedFile"><span>'+input.files[i].name+'</span></div>');
                    fileElem.prepend(button);
                    fileElem.appendTo(placeholder);
                }
            }
        };
        $('#ContactFormFile').on('change', function() {
            previewImages(this, 'div.contactSelectedFiles');
        });
    });

    let searchParams = new URLSearchParams(window.location.search);
    if(searchParams.has('error')) {
        let errorMessage = $('#ContactFormErrorMessage');
        errorMessage.html(searchParams.get('error'));
        errorMessage.show();
    } else if(searchParams.has('success')) {
        $('#ContactFormSuccessMessage').show();
    }

    $(function(){
      $('#ContactCategory').on('change', function() {
        let val = $(this).val();
        $('#ContactFormOrder').attr('placeholder', 'Order Number');
        if(['category1', 'category4', 'category5'].includes(val)) {
          $('#ContactFormOrder').attr('placeholder', 'Order Number*');
        }
      });
      let formSubmitted = false;
      $('#contact_form').on('submit', function (e) {
        if (!validateContactForm()) {
          toastr.error('Please make sure all fields are filled in correctly.');
          return false;
        } else if (formSubmitted) {
          return false;
        }
        formSubmitted = true;
        $('#submitButton').addClass('loading');
      });
    });


    function validateContactForm(){
      let hasError = false;
      $('#contact_form input, #contact_form textarea, #contact_form .customSelect').removeClass('error');
      if(!$('#ContactCategory').val()) {
        $('#contact_form .customSelect').addClass('error');
        hasError = true;
      }

      if(!($('#ContactFormName').val() && $('#ContactFormName').val().length>=2)) {
        $('#ContactFormName').addClass('error');
        hasError = true;
      }

      if(['category1', 'category4', 'category5'].includes($('#ContactCategory').val()) && !$('#ContactFormOrder').val()) {
        $('#ContactFormOrder').addClass('error');
        hasError = true;
      }

      if(!($('#ContactFormMessage').val() && $('#ContactFormMessage').val().length>=2)) {
        $('#ContactFormMessage').addClass('error');
        hasError = true;
      }

      if(!validateEmail($('#ContactFormEmail').val())) {
        $('#ContactFormEmail').addClass('error');
        hasError = true;
      }

      return !hasError;
    }

    function validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    $(window).click(function() {
      $('.customSelectOptions').hide();
      $('.customSelect').attr('aria-expanded', false);
    });

    $('.customSelectValue').on('click', function(e) {
      e.stopPropagation();

      let $this = $(this);
      let $topic = $this.parent();
      let $items = $topic.find('.customSelectOptions');
      let isExpanded = $topic.attr('aria-expanded') !== 'false';
      
      if(!isExpanded) {
        $items.show();
      } else {
        $items.hide();
      }

      $topic.attr('aria-expanded', !isExpanded);
    });

    $('.customSelectOption').click(function(event){
      let $select = $(this).closest('.customSelect');
      let $selectValue = $select.find('.customSelectValue');
      let $options = $select.find('.customSelectOptions');
      let $input = $select.find('input');
      let value = $(this).data('value');

      $selectValue.text($(this).text());
      $input.val(value).trigger('change');
      $options.hide();
      $select.attr('aria-expanded', false);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-article-contact"]) return;
  try {
    
  $('.faqTopicTitle').on('click', function() {
    let $this = $(this);
    let $topic = $this.parent();
    let $items = $topic.find('.faqTopicItems');
    let isExpanded = $topic.attr('aria-expanded') !== 'false';
    
    if(!isExpanded) {
      $items.slideDown(200);
    } else {
      $items.slideUp(200);
    }

    $topic.attr('aria-expanded', !isExpanded);
  });

    document.addEventListener("DOMContentLoaded",function(event) {

        $('#fileButton').on('click', function() {
            $('#ContactFormFile').click();
        });
        var previewImages = function(input, placeholder) {
            $(placeholder).html('');
            if (input.files) {
                let filesAmount = input.files.length;
                for (let i = 0; i < filesAmount; i++) {
                    let button = $('<div class="selectedFileRemoveButton"></div>');
                    button.on('click', function () {
                        let dt = new DataTransfer();
                        let files = input.files;

                        for (let j = 0; j < files.length; j++) {
                            let file = files[j];
                            if (i !== j)
                                dt.items.add(file) // here you exclude the file. thus removing it.
                        }

                        input.files = dt.files ;
                        previewImages(input, placeholder);
                    });
                    let fileElem = $('<div class="selectedFile"><span>'+input.files[i].name+'</span></div>');
                    fileElem.prepend(button);
                    fileElem.appendTo(placeholder);
                }
            }
        };
        $('#ContactFormFile').on('change', function() {
            previewImages(this, 'div.contactSelectedFiles');
        });
    });

    let searchParams = new URLSearchParams(window.location.search);
    if(searchParams.has('error')) {
        let errorMessage = $('#ContactFormErrorMessage');
        errorMessage.html(searchParams.get('error'));
        errorMessage.show();
    } else if(searchParams.has('success')) {
        $('#ContactFormSuccessMessage').show();
    }

    $(function(){
      $('#ContactCategory').on('change', function() {
        let val = $(this).val();
        $('#ContactFormOrder').attr('placeholder', 'Order Number');
        if(['category1', 'category4', 'category5'].includes(val)) {
          $('#ContactFormOrder').attr('placeholder', 'Order Number*');
        }
      });
      let formSubmitted = false;
      $('#contact_form').on('submit', function (e) {
        if (!validateContactForm()) {
          toastr.error('Please make sure all fields are filled in correctly.');
          return false;
        } else if (formSubmitted) {
          return false;
        }
        formSubmitted = true;
        $('#submitButton').addClass('loading');
      });
    });


    function validateContactForm(){
      let hasError = false;
      $('#contact_form input, #contact_form textarea, #contact_form .customSelect').removeClass('error');
      if(!$('#ContactCategory').val()) {
        $('#contact_form .customSelect').addClass('error');
        hasError = true;
      }

      if(!($('#ContactFormName').val() && $('#ContactFormName').val().length>=2)) {
        $('#ContactFormName').addClass('error');
        hasError = true;
      }

      if(['category1', 'category4', 'category5'].includes($('#ContactCategory').val()) && !$('#ContactFormOrder').val()) {
        $('#ContactFormOrder').addClass('error');
        hasError = true;
      }

      if(!($('#ContactFormMessage').val() && $('#ContactFormMessage').val().length>=2)) {
        $('#ContactFormMessage').addClass('error');
        hasError = true;
      }

      if(!validateEmail($('#ContactFormEmail').val())) {
        $('#ContactFormEmail').addClass('error');
        hasError = true;
      }

      return !hasError;
    }

    function validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    $(window).click(function() {
      $('.customSelectOptions').hide();
      $('.customSelect').attr('aria-expanded', false);
    });

    $('.customSelectValue').on('click', function(e) {
      e.stopPropagation();

      let $this = $(this);
      let $topic = $this.parent();
      let $items = $topic.find('.customSelectOptions');
      let isExpanded = $topic.attr('aria-expanded') !== 'false';
      
      if(!isExpanded) {
        $items.show();
      } else {
        $items.hide();
      }

      $topic.attr('aria-expanded', !isExpanded);
    });

    $('.customSelectOption').click(function(event){
      let $select = $(this).closest('.customSelect');
      let $selectValue = $select.find('.customSelectValue');
      let $options = $select.find('.customSelectOptions');
      let $input = $select.find('input');
      let value = $(this).data('value');

      $selectValue.text($(this).text());
      $input.val(value).trigger('change');
      $options.hide();
      $select.attr('aria-expanded', false);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-main"]) return;
  try {
    

  document.addEventListener("DOMContentLoaded",function(event) {
    let searchItems = [];
    $('.faqTopicItem').each(function() {
      let link = $(this).attr('href');
      let text = $(this).find('h4').text();
      searchItems.push({link: link, text: text});
    });
    

    let fuse = new Fuse(searchItems, {
      isCaseSensitive: false,
      shouldSort: true,
      includeMatches: false,
      keys: [
        "text"
      ]
    });

    function search(val) {
      if(val.length === 0) {
        $suggestionsContainer.hide();
        $suggestionsContainer.html('');
        return;
      }

      let query = fuse.search(val);

      if(query.length > 0) {
        $suggestionsContainer.html('');
        query.forEach(function(e) {
          $suggestionsContainer.append('<a href="'+e.item.link+'" class="faqSearchSuggestion"><h4>'+e.item.text+'</h4></a>');
        });
        $suggestionsContainer.show();
      }
    }

    let $suggestionsContainer = $('.faqSearchSuggestions');

    $('.faqSearchInput').keyup(function(e) {
      let code = (e.keyCode ? e.keyCode : e.which);
      switch (code) {
        case 40: //down key
        case 38: //up key
          //add more cases for special buttons
          return;
      }

      let val = $(this).val();

      search(val);
      
    });


    $('.faqTopicTitle').on('click', function() {
      let $this = $(this);
      let $topic = $this.parent();
      let $items = $topic.find('.faqTopicItems');
      let isExpanded = $topic.attr('aria-expanded') !== 'false';
      
      if(!isExpanded) {
        $items.slideDown(200);
      } else {
        $items.slideUp(200);
      }

      $topic.attr('aria-expanded', !isExpanded);
    });

    $(window).click(function() {
      $('.faqSearchSuggestions').hide();
    });

    $('.faqSearchSuggestions').click(function(event){
      event.stopPropagation();
    });

    $('.faqSearchContainer').click(function(event){
      search($('.faqSearchInput').val());
      event.stopPropagation();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      this.transparentHeaderSection = document.querySelector('main section:first-of-type.header-transparent');
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if(this.transparentHeaderSection){
        if(scrollTop > this.transparentHeaderSection.offsetTop + this.transparentHeaderSection.offsetHeight - this.header.offsetHeight){
            this.header.classList.add('force-bg');
        }else{
            this.header.classList.remove('force-bg');
        }
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      //this.closeMenuDisclosure();
      //this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
